// ** Custom Components
import Box from "../Box"
import Button from "../Button"
import Container from "../Container"
import Heading from "../Heading"
import SectionLink from "../SectionLink"

const SectionCTA = ({ section }: any) => {
  const { title, listItems } = section
  return (
    <Container
      fullWidthOnMobile={false}
      className="!w-screen !max-w-7xl mx-auto"
    >
      <Box className="px-8 md:px-6 lg:px-10 py-8 md:py-14 flex flex-col justify-between md:flex-row gap-y-8 md:gap-y-0 items-center bg-zinc-100 rounded-[20px]">
        <Heading
          as="h3"
          className="inline-block text-blue-500 text-center md:text-left sm:pr-8"
        >
          {title}
        </Heading>
        <SectionLink link={listItems[0]?.linkPrimary}>
          <Button className="bg-blue-500 w-full md:w-max !rounded-[20px] text-white text-bold py-6 px-24 lg:px-32 !text-xl lg:fluid-md lg:mr-0">
            {listItems[0]?.linkPrimary?.title}
          </Button>
        </SectionLink>
      </Box>
    </Container>
  )
}

export default SectionCTA
